export const ACH_ACCOUNT_TYPES = ["checking", "savings"] as const;

export type AchAccountType = (typeof ACH_ACCOUNT_TYPES)[number];

export type CardPaymentMethod = {
  brand: string;
  expiryMonth: number;
  expiryYear: number;
  id: string;
  last4: string;
  type: "card";
};

export type AchPaymentMethod = {
  accountHolderName: string;
  accountType: AchAccountType;
  bankName: string;
  id: string;
  last4: string;
  routingNumber: string;
  type: "ach";
};

export type PaymentMethod = AchPaymentMethod | CardPaymentMethod;

export type PaymentMethodType = PaymentMethod["type"];

export type PaymentMethods = {
  backupMethods: PaymentMethod[];
  defaultMethod: PaymentMethod;
};

export type PaymentMethodSlot =
  | { index: number; kind: "backup" }
  | { kind: "default" };

export type PaymentMethodAction =
  | {
      method: PaymentMethod;
      setAsDefault: boolean;
      slot: PaymentMethodSlot;
      type: "update";
    }
  | { index: number; type: "remove" }
  | { method: PaymentMethod; setAsDefault: boolean; type: "add" };

export interface PaymentMethodFormProps<TMethod> {
  readonly currentMethod: null | TMethod;
  readonly formId: string;
  readonly onSubmit: (resolveMethod: () => Promise<PaymentMethod>) => void;
  readonly onValidityChange: (isValid: boolean) => void;
}
